import { Fade, Grid2 } from '@mui/material'
import KeyboardKeys from './keyboardKeys'

interface MoovyVirtualKeyboardProps {
  open: boolean
  handleVirtualKeyboardInput: (key: string) => void
  useMoovyKeyboard: boolean
}

const MoovyVirtualKeyboard = ({
  open,
  handleVirtualKeyboardInput,
  useMoovyKeyboard
}: MoovyVirtualKeyboardProps) => {
  return (
    <Fade in={open} unmountOnExit>
      <Grid2
        sx={{
          backgroundColor: '#E0E0E0',
          borderRadius: '10px',
          padding: '2px'
        }}
      >
        {useMoovyKeyboard && (
          <KeyboardKeys onKeyPress={handleVirtualKeyboardInput} />
        )}
      </Grid2>
    </Fade>
  )
}

export default MoovyVirtualKeyboard
